import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { createCaslGuard } from '@/lib/auth/permissionGuards';
import { ProcessEditorLandingPage } from '@/pages/processes/editor/ProcessEditorLandingPage';

const processEditorSearchSchema = z.object({
  department: z.string().optional().catch(undefined)
});

export const Route = createFileRoute('/$slug/processes/editor/')({
  beforeLoad: createCaslGuard('ProcessEditor'),
  component: ProcessEditorLandingPage,
  validateSearch: processEditorSearchSchema
});
